import { get } from 'lodash';
import { api } from 'utils/hooks/useApi';

import { IFindDocumentsMetadataRequest, IPatientRequest, IPatientResponse } from './_types';
import { IPatientInformation } from '../Patient/_types';

export const findPatients = (data: IPatientRequest): Promise<IPatientResponse[]> | boolean =>
  api()
    .post(`/portal-api/clinicalPortalFhir/findPatients`, data)
    .then((response) => get(response, 'data'))
    .catch((error) => false);

export const findDocuments = (masterPatientID: any, bookmarkId: any): Promise<any> | boolean =>
  api()
    .get(`/portal-api/clinicalPortalFhir/findDocuments`, {
      params: { masterPatientID, bookmarkId },
    })
    .then((response) => get(response, 'data'))
    .catch((error) => false);

export const getPatientInformation = (masterPatientID: string): Promise<IPatientInformation> =>
  api()
    .get(`/portal-api/clinicalPortalFhir/getPatientInformation`, {
      params: { masterPatientID },
    })
    .then((response) => {
      return get(response, 'data');
    })
    .catch((error) => false);

export const getDocument = (
  masterPatientID: any,
  uuid: string,
  typeOfDocument: string,
): Promise<any> =>
  api()
    .get(`/portal-api/clinicalPortalFhir/getDocument`, {
      params: { masterPatientID, uuid, typeOfDocument },
    })
    .then((response) => {
      return get(response, 'data');
    })
    .catch((error) => false);

export const getBookmarksDocumentCount = (
  masterPatientID: string,
  bookmarkIds: number[] = [],
): Promise<{
  [activeTab: string]: number;
}> =>
  api()
    .get(`/portal-api/clinicalPortalFhir/getBookmarksDocumentCount`, {
      params: { masterPatientID, bookmarkIds },
    })
    .then((response) => {
      return get(response, 'data');
    })
    .catch((error) => false);

export const findDocumentsMetadata = (
  data: IFindDocumentsMetadataRequest,
): Promise<any[]> | boolean =>
  api()
    .post(`/portal-api/clinicalPortalFhir/findDocumentsMetadata`, data)
    .then((response: any) => get(response, 'data'))
    .catch((error: Error) => false);
